import React from "react"

export const PostHeader = ({ title, date }) => (
         <div>
           <h1 className={"post-title"}>{title}</h1>
           <p className={"post-date"}>{date}</p>
         </div>
       )

         
       
